import React from "react";
import {Link} from "gatsby";
import propTypes from 'prop-types';

const Button = ({onClick, children, ...rest}) => {
    let classList = `${rest.btnType} ${rest.color} ${rest.variant} ${rest.size}`;
    let disabled = rest.inactive && 'disabled';
    return rest.link ? (rest.link.includes(".pdf" || ".pptx" || ".zip") ? <a href={rest.link} className={classList} disabled={disabled} aria-label={rest.labelText} target="_blank" rel="noreferrer">{children}</a>:<Link to={rest.link} className={classList} disabled={disabled} aria-label={rest.labelText}>{children}</Link>): 
    rest.closeModal ? 
        <button type={rest.type} data-close-modal aria-expanded={rest.ariaExpanded} aria-label={rest.labelText} className={classList} disabled={disabled} onClick={onClick}>{children}</button>
        :
        <button type={rest.type} aria-expanded={rest.ariaExpanded} aria-label={rest.labelText} className={classList} disabled={disabled} onClick={onClick} title={rest.title}>{children}</button>
}
export default Button;
Button.propTypes = { 
    btnType: propTypes.string,
    color: propTypes.oneOf(['primary-button','usa-button--secondary', 'usa-button--accent-cool', 'usa-button--accent-warm', 'usa-button--base', 'usa-button--unstyled', '']),
    type: propTypes.oneOf(['submit', 'reset', 'button']),
    size: propTypes.string,
    variant: propTypes.oneOf(['usa-button--outline', 'usa-button--inverse','']),
    disabled: propTypes.oneOf([true, false]),
    closeModal: propTypes.oneOf([true, false]),
    title: propTypes.string
}
Button.defaultProps = {
    btnType: 'usa-button',
    color: '',
    type: 'button',
    variant: '',
    size: '',
    title: '',
    inactive: false,
    closeModal: false
}